import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CardProps {
  children: ReactNode;
  className?: string;
  title?: string;
  hover?: boolean;
  glass?: boolean;
}

export function Card({ children, className, title, hover = false, glass = true }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-2xl p-6 transition-all duration-300',
        glass ? 'glass shadow-glass' : 'bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 shadow-xl',
        hover && 'hover:scale-[1.02] hover:shadow-glass-lg cursor-pointer',
        className
      )}
    >
      {title && (
        <h3 className="mb-4 text-xl font-bold gradient-text">
          {title}
        </h3>
      )}
      {children}
    </div>
  );
}